import { apiDelete, apiGet, apiPost } from './CustomerApi';

export async function getMicroContentList() {
    const path = `/api/microcontent`;

    return apiGet(path)
        .then((data) => {
            return data || [];
        })
        .catch((err) => {
            console.error('getMicroExperienceList : FAILED : ', err);
            throw new Error('getMicroExperienceList : FAILED : ' + JSON.stringify(err));
        });
}

export function getMicroExperienceListForCustomer(customerId) {
    const path = `/api/customer/${customerId}/microexperiences`;
    return apiGet(path)
        .then((data) => {
            return data || [];
        })
        .catch((err) => {
            console.error('getMicroExperienceListForCustomer : FAILED : ', err);
            throw new Error('getMicroExperienceListForCustomer : FAILED : ' + JSON.stringify(err));
        });
}

export function getMicroExperienceBookingsListForCustomer(customerId) {
    const path = `/api/customer/${customerId}/microexperiences/bookings`;
    return apiGet(path)
        .then((data) => {
            return data || [];
        })
        .catch((err) => {
            console.error('getMicroExperienceBookingsListForCustomer : FAILED : ', err);
            throw new Error('getMicroExperienceBookingsListForCustomer : FAILED : ' + JSON.stringify(err));
        });
}

export function getWishListForCustomer(customerId) {
    const path = `/api/customer/${customerId}/experience/wishlist`;
    return apiGet(path)
        .then((data) => {
            return data || [];
        })
        .catch((err) => {
            console.error('getWishListForCustomer : FAILED : ', err);
            throw new Error('getWishListForCustomer : FAILED : ' + JSON.stringify(err));
        });
}

export function saveMicroExperienceForCustomer(customerId, microexperience) {
    const path = `/api/customer/${customerId}/microexperiences`;
    return apiPost(path, microexperience)
        .then((data) => {
            return data || {};
        })
        .catch((err) => {
            console.error('saveMicroExperienceForCustomer : FAILED : ', err);
            throw new Error('saveMicroExperienceForCustomer : FAILED : ' + JSON.stringify(err));
        });

}

export function deleteMicroExperienceForCustomer(mxid) {
    const path = `/api/microexperiences/${mxid}`;
    return apiDelete(path)
        .then((data) => {
            return data || [];
        })
        .catch((err) => {
            console.error('deleteMicroExperienceForCustomer : FAILED : ', err);
            throw new Error('deleteMicroExperienceForCustomer : FAILED : ' + JSON.stringify(err));
        });
}